import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { UserEditPage } from "~/domain/common";

export function LqsUserEditPage() {
  return <UserEditPage breadcrumbs={<DataStoreBreadcrumbs />} />;
}
